export default "__VITE_ASSET__ClR6Xqgn__"